/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { messaging_ConversationTargetRequest } from './messaging_ConversationTargetRequest';
import type { models_ConversationType } from './models_ConversationType';
export type messaging_CreateConversationRequest = {
    allow_comments?: boolean;
    /**
     * Audience is family (parent correspondence, the default) or staff (staff-internal
     * thread). Parents may not create staff conversations.
     */
    audience?: messaging_CreateConversationRequest.audience;
    /**
     * Category is general (default), callback_request (office or groups) or wellbeing_check
     * (groups only, at least one child). Only parents may send a non-general category, and it
     * needs a subject.
     */
    category?: messaging_CreateConversationRequest.category;
    /**
     * ChildID is the legacy single child. With ChildIDs it must equal ChildIDs[0].
     */
    child_id?: string;
    /**
     * ChildIDs are the children the thread is about (1-20; more than one for parents only).
     */
    child_ids?: Array<string>;
    initial_message?: string;
    participant_contact_ids?: Array<string>;
    subject?: string;
    target_id?: string;
    /**
     * TargetType/TargetID are required unless Targets is sent (a staff conversation, or a
     * parent's family conversation); the server mirrors the first entry of Targets into them.
     */
    target_type?: string;
    /**
     * Targets is the full target set of a staff conversation (1-50 entries), or of a parent's
     * family conversation (exactly one office target, or 1-20 group targets). Not allowed for
     * an employee's family conversation.
     */
    targets?: Array<messaging_ConversationTargetRequest>;
    type: models_ConversationType;
};
export namespace messaging_CreateConversationRequest {
    /**
     * Audience is family (parent correspondence, the default) or staff (staff-internal
     * thread). Parents may not create staff conversations.
     */
    export enum audience {
        FAMILY = 'family',
        STAFF = 'staff',
    }
    /**
     * Category is general (default), callback_request (office or groups) or wellbeing_check
     * (groups only, at least one child). Only parents may send a non-general category, and it
     * needs a subject.
     */
    export enum category {
        GENERAL = 'general',
        CALLBACK_REQUEST = 'callback_request',
        WELLBEING_CHECK = 'wellbeing_check',
    }
}

